import axios from "axios";
// Asegúrate de que `useAuthStore` esté disponible o implementa una lógica alternativa si no usas Vuex o Pinia
import { useAuthStore } from "@/stores/auth";

// Verificar si estamos en producción con las variables de entorno
const isProduction = import.meta.env.VITE_APP_ENV === "production" || true;

const PRODUCTION = {
  api: isProduction ? true : false,
  tienda: isProduction ? true : false,
  caja: isProduction ? true : false,
  billetera: isProduction ? true : false,
};

// ENDPOINTS
const api = axios.create({
  baseURL: PRODUCTION.api
    ? "https://backend.orsai.org/apis"
    : "http://localhost:8080/apis",
  timeout: 60000,
});

const apiTienda = axios.create({
  baseURL: PRODUCTION.tienda
    ? "https://backend.orsai.org/api/tienda"
    : "http://localhost:8083/api/tienda",
  timeout: 60000,
});

const apiCaja = axios.create({
  baseURL: PRODUCTION.caja
    ? "https://backend.orsai.org/api/caja/v1" :
    "http://localhost:6602/api/caja/v1",
  timeout: 60000,
});

const apiBilletera = axios.create({
  baseURL: PRODUCTION.billetera
    ? "https://backend.orsai.org/api/billetera/v1/"
    : "http://localhost:6602/api/billetera/v1",
  timeout: 60000,
});

const apiUsuarios = axios.create({
  baseURL: PRODUCTION.caja
    ? "https://backend.orsai.org/apis/usuarios/v1/"
    : "http://localhost:8080/apis/usuarios/v1/",
  timeout: 60000,
});

// /wm-chorro/v1
const apiTextos = axios.create({
  baseURL: PRODUCTION.api
    ? "https://backend.orsai.org/apis/wm-chorro/v1"
    : "http://localhost:8080/apis/wm-chorro/v1",
  timeout: 60000,
});

// TOKEN
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(";").shift();
  }
  return null;
};

const authInterceptor = (config) => {
  // Obtener token del store
  const tokenStore = useAuthStore().token;
  const tokenCookie = getCookie("orsai_token");

  const token = tokenStore || tokenCookie;
  
  console.log('🔐 Interceptor de autenticación:', {
    tokenStore: tokenStore ? 'EXISTS' : 'MISSING',
    tokenCookie: tokenCookie ? 'EXISTS' : 'MISSING',
    finalToken: token ? 'EXISTS' : 'MISSING',
    url: config.url
  });

  if (token && !config.headers["Authorization"]) {
    config.headers["Authorization"] = "Basic " + token;
    console.log('✅ Header de autorización agregado');
  }
  return config;
};

api.interceptors.request.use(authInterceptor);
apiTienda.interceptors.request.use(authInterceptor);
apiCaja.interceptors.request.use(authInterceptor);
apiBilletera.interceptors.request.use(authInterceptor);
apiTextos.interceptors.request.use(authInterceptor);

// Export the custom Axios instance
export { api, apiTienda, apiCaja, apiBilletera, apiUsuarios, apiTextos };
